export default {"src":"/_next/static/media/user-outlined.cf2fd48b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};